/* eslint-disable react/prop-types */
import React from 'react';
import { Box } from '@mui/joy';
import { ReactComponent as OmrSvg } from '../../../assets/Omr_symbol.svg';

/**
 * Official Omani Rial symbol (vector). Use next to amounts instead of the “OMR” text.
 */
export default function OmrSymbol({ height = 14, sx, ...rest }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        verticalAlign: 'middle',
        lineHeight: 0,
        height,
        mx: 0.25,
        '& svg': {
          height: '100%',
          width: 'auto',
          maxWidth: '100%',
          display: 'block',
        },
        ...sx,
      }}
      aria-label="OMR"
      role="img"
      {...rest}
    >
      <OmrSvg />
    </Box>
  );
}
